import React from 'react';
import { Box, Typography, Stack } from '@mui/material';
import SectionContainer from './SectionContainer';
import SectionEyebrow from './SectionEyebrow';
import { featureHighlights } from './content';

const FeatureHighlights = () => (
  <SectionContainer id="product" sx={{ py: { xs: 6, md: 10 } }}>
    <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, alignItems: 'center', gap: { xs: 5, md: 8 } }}>
      <Box sx={{ flex: 1, width: '100%' }}>
        <Box
          sx={(theme) => ({
            borderRadius: 4,
            p: { xs: 1.25, md: 2.25 },
            bgcolor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.03)' : '#EEF2FF',
            border: '1px solid',
            borderColor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.08)' : 'rgba(37,99,235,0.12)',
          })}
        >
          <Box
            component="img"
            src="/app-home.png"
            alt="Remembr dashboard showing recent diaries and spend breakdown"
            sx={{ width: '100%', display: 'block', borderRadius: 3, boxShadow: '0 20px 45px rgba(15,23,42,0.18)' }}
          />
        </Box>
      </Box>

      <Box sx={{ flex: 1, width: '100%' }}>
        <SectionEyebrow color="primary.main">Designed for Smarter Tracking</SectionEyebrow>
        <Typography variant="h2" sx={{ fontWeight: 700, mb: 1.5, fontSize: { xs: 24, md: 32 } }}>
          Everything you need to stay on top of every service
        </Typography>
        <Typography sx={{ color: 'text.secondary', mb: 4, fontSize: { xs: 14, md: 16 } }}>
          From reminders to spend insights, Remembr keeps every recurring bill and maintenance task
          organised in one place.
        </Typography>

        <Stack spacing={2.5}>
          {featureHighlights.map(({ title, description, color, Icon }) => (
            <Box key={title} sx={{ display: 'flex', gap: 2, alignItems: 'flex-start' }}>
              <Box
                sx={{
                  width: 40,
                  height: 40,
                  minWidth: 40,
                  borderRadius: '12px',
                  bgcolor: `${color}1A`,
                  color,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <Icon fontSize="small" />
              </Box>
              <Box>
                <Typography sx={{ fontWeight: 600, fontSize: 15.5 }}>{title}</Typography>
                <Typography sx={{ color: 'text.secondary', fontSize: 14 }}>{description}</Typography>
              </Box>
            </Box>
          ))}
        </Stack>
      </Box>
    </Box>
  </SectionContainer>
);

export default FeatureHighlights;
